import Flickity from 'flickity';

class Carousel {
    constructor(passedElement, options = {}) {
        let self = this;

        self.elem = passedElement;
        self.options = options;
        self.flickity = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.flickity = new Flickity(self.elem, self.options);
        return self;
    }

    destroy() {
        let self = this;

        if (self.flickity) {
            self.flickity.destroy();
            self.flickity = null;
        }
    }
}

export default Carousel;
